import _useEffect from 'hooks/_useEffect'

const _useWillUnmount = (fn, deps = []) =>
	_useEffect(() => () => fn && fn(), deps)

export default _useWillUnmount
